module.exports = __webpack_public_path__ + "img/logo-partner-gex.b47a0600.png";